export enum FastModelProduct {
  FAST_DRAW = "FASTDRAW",
  FAST_SCOUT = "FASTSCOUT2",
  FAST_RECRUIT = "FASTRECRUIT",
  FAST_ACCESS = "FASTACCESS",
}
